import {
  Button, Grid, makeStyles,
  Paper
} from "@material-ui/core";
import ContentTitle from "components/common/ContentTitle";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useModalLoading from "libs/hooks/useModalLoading";
import mime from "mime";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SignaturePad from "react-signature-canvas";
import { getPersonalDetail } from "redux/modules/personalSlice";
import FileService from "services/FileService";
import PersonalService from "services/PersonalService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  sigContainer: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundColor: "#fff",
    marginTop: 24,
    marginBottom: 24
  },
  sigPad: { width: "100%", height: 217 },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "100%",
    height: 217,
    backgroundColor: "white",
    borderRadius: 15,
  },
  wrapSig: {
    padding: "10px",
    border: "1px solid lightgray",
    borderRadius: "10px",
    textAlign: "center",
  },
}));

function PersonalSignature() {
  const classes = useStyles();
  const sigPad = useRef({});
  const dispatch = useDispatch()
  const { personalDetail, personalId } = usePersonalDetail()
  const [signDataUri, setSignDataUri] = useState(null);
  const { showLoading, hideLoading } = useModalLoading();

  const getSignatureFile = async () => {
    const data = await FileService.getFile(personalDetail?.signatureFileID);
    try {
      const fileName = personalDetail.filename + personalDetail.ext;
      const blobFile = new File([data], fileName, {
        type: mime.getType(personalDetail.ext),
      });
      setSignDataUri(URL.createObjectURL(blobFile));
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (personalDetail?.signatureFileID) {
      getSignatureFile()
    }
  }, [personalDetail]);

  const clear = () => {
    sigPad.current && sigPad.current.clear();
    setSignDataUri(null);
  };

  const updateNewSignature = async () => {
    showLoading();

    try {
      const sigFile = sigPad.current.getTrimmedCanvas().toDataURL("image/png");
      const filesignDataUri = await fetch(sigFile)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "signImg.png", { type: "image/png" });
          return file;
        });

      const resSign = await FileService.uploadFile({
        file: filesignDataUri,
        Status: true,
      });

      await PersonalService.addPersonalSignature({
        personalID: personalId,
        signatureFileID: resSign.results?.fileID,
      })
      await dispatch(getPersonalDetail({ personalId: personalId }))

      MySwal.fire(
        "Success!",
        "Create new signature successfully !",
        "success"
      )

    } catch (error) {
      MySwal.fire(
        "Error!",
        error?.message ?? JSON.stringify(error),
        "error"
      )
    } finally {
      hideLoading();
    }
  };


  return (
    <Paper className={classes.paper}>
      <ContentTitle subTitle="Personal signature" title="Signature" />
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.sigContainer}>
            {!signDataUri && (
              <div
                style={{
                  border: "1px solid darkgray",
                  borderRadius: "15px",
                }}
              >
                <SignaturePad
                  canvasProps={{ className: classes.sigPad }}
                  ref={sigPad}
                />
              </div>
            )}
            {signDataUri ? (
              <div className={classes.wrapSig}>
                <img className={classes.sigImage} src={signDataUri} />
              </div>
            ) : null}
          </div>
        </Grid>
        {signDataUri && (
          <div style={{ display: 'flex', flex: 1, flexDirection: 'row', gap: 24, justifyContent: 'center' }}>
            <div style={{ marginBottom: 15 }}>
              <Button
                variant="outlined"
                color="primary"
                // size="small"
                type="button"
                onClick={() => {
                  setSignDataUri(null);
                }}
                className={classes.buttonViewDetail}
              >
                New Signature
              </Button>
            </div>
          </div>
        )}
        {!signDataUri && (
          <div style={{ display: 'flex', flex: 1, flexDirection: 'row', gap: 24, justifyContent: 'center' }}>
            <div style={{ marginBottom: 15 }}>
              <Button
                variant="outlined"
                color="primary"
                // size="small"
                onClick={getSignatureFile}
                type="button"
                className={classes.buttonViewDetail}
              >
                Cancel
              </Button>
            </div>
            <div style={{ marginBottom: 15 }}>
              <Button
                variant="outlined"
                color="primary"
                // size="small"
                onClick={clear}
                type="button"
                className={classes.buttonViewDetail}
              >
                Clear
              </Button>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                // size="small"
                type="button"
                onClick={updateNewSignature}
                className={classes.buttonViewDetail}
              >
                Create New Signature
              </Button>
            </div>
          </div>
        )}
      </Grid>
    </Paper>
  )
}

export default PersonalSignature